import styled, { css } from 'styled-components';
import { paddingVertical, multiplePixel } from '@styles/utils';
import phoneImg = require('./phone.png');

const phoneWidth = 820;
const phoneHeight = 1680;

const phonePaddingLeft = 51;
const phonePaddingRight = 47;
const phonePaddingVert = 199;

const contentWidth = phoneWidth - (phonePaddingLeft + phonePaddingRight);
const contentHeight = phoneHeight - 2 * phonePaddingVert;

export const phoneFrameSizes = {
  width: phoneWidth,
  height: phoneHeight,
  paddingLeft: phonePaddingLeft,
  paddingRight: phonePaddingRight,
  paddingVert: phonePaddingVert,
  contentWidth,
  contentHeight,
};

type PhoneFrameWrapperProps = {
  phoneScale?: number;
};

// tslint:disable-next-line:no-any
export const PhoneFrameWrapper = styled<PhoneFrameWrapperProps>('div' as any)`
  ${(props: PhoneFrameWrapperProps) =>
    props.phoneScale
      ? css`
          transform: scale(${props.phoneScale});
        `
      : ''}
  ${paddingVertical(phonePaddingVert)}
  padding-left: ${phonePaddingLeft}px;
  padding-right: ${phonePaddingRight}px;
  width: ${phoneWidth}px;
  height: ${phoneHeight}px;
  background-image: url('${phoneImg}');
  box-sizing: border-box;
  transform-origin: top left;
  position: relative;
`;

export const PhoneFrameContent = styled.div`
  overflow: hidden;
  position: absolute;
  left: ${phonePaddingLeft}px;
  right: ${phonePaddingRight}px;
  ${multiplePixel(phonePaddingVert, 'top', 'bottom')} background: white;
`;



// WEBPACK FOOTER //
// src/app/src/components/PhoneFrame/PhoneFrame.s.ts